__turbopack_context__.v({
  "cautions": "CommonCautions-module-scss-module__b0LdlW__cautions",
  "cautions_inner": "CommonCautions-module-scss-module__b0LdlW__cautions_inner",
  "cautions_list": "CommonCautions-module-scss-module__b0LdlW__cautions_list",
  "cautions_list_no_bullet": "CommonCautions-module-scss-module__b0LdlW__cautions_list_no_bullet",
  "cautions_title": "CommonCautions-module-scss-module__b0LdlW__cautions_title",
  "cautions_title_button": "CommonCautions-module-scss-module__b0LdlW__cautions_title_button",
  "cautions_title_icon": "CommonCautions-module-scss-module__b0LdlW__cautions_title_icon",
});
